export default __webpack_public_path__ + "static/media/Bonus.4bd2b59c.png";